import React from 'react'
import Image from 'next/image'
import { s3Static } from '../../utils/constants'

export const AndroidAppInstall = () => {
  return (
    <>        
        <a href="https://play.google.com/store/apps/details?id=com.stringssg.app" target="_blank" rel="noreferrer" className='flex justify-center'>
                <Image  
                height={42} 
                width={130} 
                style={{width: "130px", height: "42px"}}
                priority={false}
                src={s3Static + "google-play-badge.png"} 
                alt="StringsSG google play"/>
        </a>
    </>
  )
}
